<div [ngClass]="_containerClass">
    <input
        #inputElement
        [(ngModel)]="value"
        [ngClass]="_inputClass"
        [autocomplete]="autocomplete"
        [autocapitalize]="autocapitalize"
        [spellcheck]="spellcheck"
        [disabled]="disabled"
        [required]="!!required"
        [minlength]="minlength"
        [maxlength]="maxlength"
        [placeholder]="placeholder"
        [autofocus]="autofocus"
        [readonly]="readonly"
        [type]="getType()"
        [attr.inputmode]="inputmode"
        [min]="min"
        [max]="max"
        [step]="step"
        [tabindex]="tabindex"
        (focus)="onFocus()"
        (blur)="onBlur()"
        (beforeinput)="onBeforeInput($event)"
        (change)="onChange($event)"
        (keydown)="onKeyDown($event)"
        (keypress)="$keypress.emit($event)"
        (keyup)="$keyup.emit($event)"
    />
    <ul
        #suggestionList
        [class]="
            'emma-input__suggestions ' +
            (dropdownPosition === 'top' ? 'emma-input__suggestions--top' : 'emma-input__suggestions--botom')
        "
        *ngIf="isOpen"
        (mouseenter)="onSuggestionsHover()"
        (mouseleave)="onSuggestionsLeave()"
    >
        <li
            *ngFor="let suggestion of visibleValues; index as index; trackBy: trackByFn"
            [class]="index === selectedSuggestion ? 'active' : ''"
            (mousedown)="onSelect(suggestion.value)"
            (mouseover)="onMouseHover(index)"
            [title]="suggestion.label ? suggestion.value + ': ' + suggestion.label : false"
        >
            {{ suggestion.value }}
            <div *ngIf="suggestion.label" class="emma-input__suggestion-help">
                {{ suggestion.label }}
            </div>
        </li>
    </ul>
    <div *ngIf="copyToClipboard" class="emma-copyToClipboard" emmaCopyToClipboard [copyValue]="value"></div>
    <div *ngIf="visibilityButton" class="emma-changeVisibility">
        <button
            #visButtonn
            emmaButton
            class="m-btn--visibility-btn"
            [isCircle]="true"
            [hasIcon]="true"
            [onlyIcon]="true"
            [noBg]="true"
            color="brand"
            (click)="onChangeVisibility()"
        >
            <i class="la" [ngClass]="{'la-eye-slash': visibility, 'la-eye': !visibility}" aria-hidden="true"></i>
        </button>
    </div>
    <div
        class="helpMessageAtError"
        #popover="ngbPopover"
        *ngIf="showHelpMessageAtError"
        [ngbPopover]="helpMessageAtError"
        [placement]="helpMessagePosition"
        triggers="manual"
    ></div>
</div>
